const promiseMngt = {
    namespaced: true,
    state : {
        promiseGoodsCd : '',
        status : '',
        promiseGoodsInfo : {},
        optionGoodsSeq : '',
    },
    getters: {
        getPromiseGoodsCd (state) {
            return state.promiseGoodsCd
        },
        getStatus (state) {
            return state.status
        },
        getPromiseGoodsInfo (state) {
            return state.promiseGoodsInfo
        },
        getOptionGoodsSeq (state) {
            return state.optionGoodsSeq
        }

    },
    mutations: {
        setPromiseGoodsCd (state, payload) {
            state.promiseGoodsCd = payload
        },
        setStatus (state, payload) {
            state.status = payload
        },
        setPromiseGoodsInfo (state, payload) {
            state.promiseGoodsInfo = payload
        },
        setOptionGoodsSeq (state, payload) {
            state.optionGoodsSeq = payload
        },

    },
    actions: {
        setPromiseGoodsCd ({commit}, payload) {
            commit('setPromiseGoodsCd', payload)
        },
        setStatus ({commit}, payload) {
            commit('setStatus', payload)
        },
        setPromiseGoodsInfo ({commit}, payload) {
            commit('setPromiseGoodsInfo', payload)
        },
        setOptionGoodsSeq ({commit}, payload) {
            commit('setOptionGoodsSeq', payload)
        },
        setPromiseinit ({commit}) {
            commit('setPromiseGoodsCd','');
            commit('setStatus','');
            commit('setPromiseGoodsInfo',{});
            commit('setOptionGoodsSeq','');
        },
    }
}


export default promiseMngt